const url = process.env.REACT_APP_API_BASE_URL;

export const productApi = {
  getAll: async () => {
    const res = await fetch(`${url}/api/admin/products`);
    return res.json();
  },

  getCategories: async () => {
    const res = await fetch(`${url}/api/admin/categories`);
    return res.json();
  },

  create: async (formData) => {
    const res = await fetch(`${url}/api/admin/products`, {
      method: 'POST',
      body: formData, 
    });
    return res.json();
  },

  update: async (id, formData) => {
    const res = await fetch(`${url}/api/admin/products/${id}`, {
      method: 'PUT',
      body: formData,
    });
    return res.json();
  },

  delete: async (id) => {
    const res = await fetch(`${url}/api/admin/products/${id}`, {
      method: 'DELETE',
    });
    return res.json();
  }
};